export const testSourceConnectionAction = 'testSourceConnectionAction';
export const testExistingSourceConnectionAction =
  'testExistingSourceConnectionAction';
export const changeSourceStatusAction = 'changeSourceStatusAction';
export const getGA4PropertiesAction = 'getGA4PropertiesAction';
export const getFacebookPagesAction = 'getFacebookPagesAction';
export const getSchemaAction = 'getSchemaAction';
